// Maps a company name → /carrier-logos/<file> in /app/frontend/public.
// Names normalize to lower-cased alphanumeric so spelling/punctuation
// variations ("AIG / Corebridge", "Foresters Financial", etc.) still match.

const FILE_MAP = {
  // exact-name keys (post-normalization)
  aetnacvs:                 'aetna-cvs logo.png',
  accendo:                  'accendo logo.png',
  aflac:                    'Aflac Logo.png',
  americanamicable:         'American Amicable Logo.png',
  americannational:         'american national logo.svg',
  americo:                  'americo.png',
  ameritas:                 'Ameritas logo.png',
  baltimorelife:            'Baltimore Life Logo.png',
  bannerlife:               'banner life logo.png',
  banner:                   'Banner.png',
  betterlife:               'better life logo.png',
  chubb:                    'Chubb Logo.png',
  cica:                     'Cica logo.png',
  cincinnatilife:           'Cincinnati life-logo.png',
  corebridge:               'corebridge logo.svg',
  ethos:                    'Ehtos Logo.png',
  familybenefitlife:        'Family Benefit Life.png',
  fidelity:                 'Fidelity Logo.png',
  gerber:                   'gerber logo.png',
  gpmlife:                  'gpm life logo.png',
  gtl:                      'gtl life logo.png',
  guardianlife:             'Guardian life logo.png',
  illinoismutual:           'illinois mutual life logo.png',
  libertybankerslife:       'liberty bankers life logo.png',
  massmutual:               'mass mutual life logo.png',
  nationallifegroup:        'national life group logo.png',
  nationwide:               'nationwide logo.svg',
  northamerican:            'north amerian life logo.png',
  oxfordlife:               'oxford life logo.png',
  pacificlife:              'Pacific Life.png',
  pennmutual:               'Penn Mutual life logo.png',
  prosperitylife:           'prosperity life logo.png',
  prudential:               'prudential life logo.svg',
  royalarcanum:             'royal arcanum life logo.png',
  royalneighbors:           'royal neighbors life logo.png',
  securitymutual:           'Security Mutual life logo.png',
  sentinelsecuritylife:     'sentinel security life logo.png',
  sonsofnorway:             'sons of norway logo.png',
  symetra:                  'symetra life logo.png',
  transamerica:             'transamerica logo.png',
  trinitylife:              'trinity life logo.png',
  unitedfarmfamilylife:     'united farm family life logo.png',
  unitedhomelife:           'united home life logo.png',
  unitedofomaha:            'united of omaha logo.png',
  mutualofomaha:            'united of omaha logo.png',
  williampenn:              'william penn life logo.png',
};

// Aliases — common variants of a company's name pointing to one canonical key.
const ALIASES = {
  aetna:               'aetnacvs',
  aetnacvshealth:      'aetnacvs',
  americanamicablelife:'americanamicable',
  bannerlifelegalgeneral:'bannerlife',
  corebridgefinancial: 'corebridge',
  aig:                 'corebridge',
  aigcorebridge:       'corebridge',
  ethoslife:           'ethos',
  guaranteetrust:      'gtl',
  guaranteetrustlife:  'gtl',
  pennmutuallife:      'pennmutual',
  prudentiallife:      'prudential',
  prudentialfinancial: 'prudential',
  symetralife:         'symetra',
  guardian:            'guardianlife',
  northamericanlife:   'northamerican',
  northamericancompanyforlifeandhealthinsurance: 'northamerican',
  pacific:             'pacificlife',
  transamericacompany: 'transamerica',
};

const normalize = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// Pre-sort keys longest-first so prefix matches favor the most specific entry
// (e.g. "americannational" before "american", "pennmutuallife" before "pennmutual").
const SORTED_KEYS = Object.keys(FILE_MAP).sort((a, b) => b.length - a.length);
const ALIAS_KEYS = Object.keys(ALIASES).sort((a, b) => b.length - a.length);

export function carrierLogoUrl(companyName) {
  if (!companyName) return null;
  const norm = normalize(companyName);
  // 1) Exact match
  if (FILE_MAP[norm]) return `/carrier-logos/${encodeURIComponent(FILE_MAP[norm])}`;
  // 2) Longest-prefix match against canonical keys
  //    (e.g. "americanamicablelifeinsurancecompany" → "americanamicable")
  for (const key of SORTED_KEYS) {
    if (norm.startsWith(key)) return `/carrier-logos/${encodeURIComponent(FILE_MAP[key])}`;
  }
  // 3) Longest-prefix against aliases
  for (const key of ALIAS_KEYS) {
    if (norm.startsWith(key)) {
      const file = FILE_MAP[ALIASES[key]];
      if (file) return `/carrier-logos/${encodeURIComponent(file)}`;
    }
  }
  return null;
}
